import type { EntityTypeMap, ValidationResult } from 'types';

export const validateEvent = (event: EntityTypeMap['event']['event']): ValidationResult => {
    if (!event.name) {
        return {
            status: 'error',
            errorMessage: 'Event Name is required!',
        };
    }
    return {
        status: 'success',
    };
};
